import * as React from 'react';
import { Dispatch } from 'react-redux';
import Popup, { FooterData } from '../Popup';
import { I18n } from 'react-redux-i18n';
import { PopupWrapper, StyledIcon, NoSaveAsInfo } from './styles';
import Utils from '../../utils';
import { StoreState } from '../../reducers';
import { closeNoSaveAsPopup } from '../../containers/NoSaveAsPopup/actions';
import { showPublicationCreator } from '../../containers/PublicationCreator/actions';
import { PublicationSource } from '../../containers/PublicationCreator/reducer';

interface NoSaveAsPopupProps {
	isDisplayed: boolean;
	dispatch: Dispatch<StoreState>;
}

const NoSaveAsPopup = ({
	isDisplayed,
	dispatch,
}: NoSaveAsPopupProps) => {
	const onCancel = () => dispatch(closeNoSaveAsPopup());
	const popupFooter: FooterData = {
		label: I18n.t('messages.create_proposal_from_template'),
		onAccept: () => {
			dispatch(showPublicationCreator(PublicationSource.TEMPLATE));
			dispatch(closeNoSaveAsPopup());
		},
	};


	return (
		<Popup
			isDisplayed={isDisplayed}
			label={I18n.t('messages.save_as')}
			onCancel={onCancel}
			footer={popupFooter}
			gallerySlot="noSaveAsPopup"
		>
			<PopupWrapper>
				<StyledIcon>{Utils.getSvgIcon('iconset_uprez_info')}</StyledIcon>
				<NoSaveAsInfo value="messages.no_save_as_info"/>
			</PopupWrapper>
		</Popup>
	);
};

export default NoSaveAsPopup;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NoSaveAsPopup/index.tsx